import React from "react";

const HotelPerformanceCell = ({ goodPercentages, loadingStats }) => {
  // Si loadingStats ou goodPercentages n'existe pas, afficher un placeholder avec la même structure
  if (loadingStats || !goodPercentages) {
    return (
      <div className="space-y-1">
        {/* Placeholder pour la valeur principale (même hauteur que le contenu réel) */}
        <div className="text-lg font-bold text-gray-300">-</div>

        {/* Placeholders pour les pourcentages secondaires */}
        <div className="grid grid-cols-4 gap-1 text-xs">
          <div className="font-medium text-center text-gray-300">-</div>
          <div className="font-medium text-center text-gray-300">-</div>
          <div className="font-medium text-center text-gray-300">-</div>
          <div className="font-medium text-center text-gray-300">-</div>
        </div>

        {/* Labels des périodes (toujours affichés) */}
        <div className="grid grid-cols-4 gap-1 text-xs text-gray-400">
          <div className="text-center">J-1</div>
          <div className="text-center">J-3</div>
          <div className="text-center">J-15</div>
          <div className="text-center">J-30</div>
        </div>
      </div>
    );
  }

  // Fonction pour sécuriser les valeurs numériques
  // Retourne null si la valeur est null (tous les modules sont "A equiper")
  const safePercentage = (value) => {
    if (value === null || value === undefined) {
      return null; // null signifie qu'il n'y a aucun module équipé
    }
    if (isNaN(value)) {
      return 0;
    }
    return typeof value === "string" ? parseFloat(value) || 0 : value;
  };

  // Extraire et sécuriser les valeurs
  const d1Percentage = safePercentage(goodPercentages.d1);
  const d3Percentage = safePercentage(goodPercentages.d3);
  const d15Percentage = safePercentage(goodPercentages.d15);
  const d30Percentage = safePercentage(goodPercentages.d30);

  // Couleur en fonction du pourcentage
  const getPercentageColor = (percentage) => {
    if (percentage === null) return "text-gray-400";
    if (percentage >= 80) return "text-green-600";
    if (percentage >= 60) return "text-yellow-600";
    if (percentage >= 40) return "text-orange-600";
    return "text-red-600";
  };

  // Formatage de l'affichage
  const formatPercentage = (percentage) => {
    if (percentage === null) return "-";
    return `${percentage.toFixed(1)}%`;
  };

  return (
    <div className="space-y-1">
      {/* Ligne principale : gros J-1 + petits J-3 / J-15 / J-30 */}
      <div className="grid grid-cols-4 gap-1 items-end">
        {/* Gros pourcentage pour J-1 */}
        <div className="text-center">
          <div className={`text-lg font-bold leading-tight ${getPercentageColor(d1Percentage)}`}>{formatPercentage(d1Percentage)}</div>
        </div>

        {/* Petits pourcentages pour J-3, J-15, J-30 */}
        <div className={`text-xs font-medium text-center ${getPercentageColor(d3Percentage)}`}>{formatPercentage(d3Percentage)}</div>
        <div className={`text-xs font-medium text-center ${getPercentageColor(d15Percentage)}`}>{formatPercentage(d15Percentage)}</div>
        <div className={`text-xs font-medium text-center ${getPercentageColor(d30Percentage)}`}>{formatPercentage(d30Percentage)}</div>
      </div>

      {/* Labels des périodes alignés sous chaque colonne */}
      <div className="grid grid-cols-4 gap-1 text-xs text-gray-400">
        <div className="text-center">J-1</div>
        <div className="text-center">J-3</div>
        <div className="text-center">J-15</div>
        <div className="text-center">J-30</div>
      </div>
    </div>
  );
};

export default HotelPerformanceCell;
